/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geolayerlabel2Inputs */

const en_geolayerlabel2 = /** @type {(inputs: Geolayerlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map layer`)
};

const de_geolayerlabel2 = /** @type {(inputs: Geolayerlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartenebene`)
};

/**
* | output |
* | --- |
* | "Map layer" |
*
* @param {Geolayerlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geolayerlabel2 = /** @type {((inputs?: Geolayerlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geolayerlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geolayerlabel2(inputs)
	return de_geolayerlabel2(inputs)
});
export { geolayerlabel2 as "geoLayerLabel" }